/**
 * 婚纱摄影：6
 * 婚礼策划：2
 * 婚纱礼服: 12
 * 婚礼录像：8
 * 婚礼跟妆：9
 * 婚礼摄影：7
 * 婚礼司仪：11
 * 婚戒首饰：14
 * 花艺甜品：15
 */
export const FIELD_CONFIG = {
  // 婚纱摄影
  6: [
    // {
    //   type: 'text',
    //   title: '拍摄地/景点',
    //   placeholder: '请输入拍摄的地点或者景点',
    //   max: 24
    // },
    {
      type: 'date',
      title: '拍摄时间',
      placeholder: '请选择拍摄时间'
    }
  ],
  // 婚礼录像
  8: [
    {
      type: 'text',
      title: '拍摄设备',
      placeholder: '请输入设备名称',
      max: 10,
      width: 240
    },
    {
      type: 'text',
      title: '拍摄团队',
      placeholder: '请输入拍摄团队',
      max: 10,
      width: 240
    },
    {
      type: 'date',
      title: '婚礼时间',
      placeholder: '请选择婚礼时间',
      width: 240
    }
  ],
  // 婚礼摄影
  7: [
    {
      type: 'text',
      title: '拍摄设备',
      placeholder: '请输入设备名称',
      max: 10,
      width: 240
    },
    {
      type: 'text',
      title: '拍摄团队',
      placeholder: '请输入拍摄团队',
      max: 10,
      width: 240
    },
    {
      type: 'date',
      title: '婚礼时间',
      placeholder: '请选择婚礼时间',
      width: 240
    }
  ]
}
